module.exports = __webpack_public_path__ + "media/tags/coton-bio-67f5e10a.png";